import React from "react";
import {headerSortingClasses, sortCaret} from "../../../_metronic/_helpers";
import {useOrdersUIContext} from "./OrdersUIContext";
import * as columnFormatters from "./column-formatters";
import moment from "jalali-moment";
import TableLayout from "../../../_metronic/_partials/controls/table/TableLayout";
import {domain} from "../../../_metronic/_helpers/GlobalConsts";
import {Image} from "react-bootstrap";
import {updateFactor, updateStatus} from "./crud/orderCrud";

export default function OrdersTable({
                                        data,
                                        activePage
                                    }) {

    const orderContext = useOrdersUIContext();

    const handleEdit = id => {
        orderContext.setId(id);
        data.data.forEach(item => {
            if (item.id === id) orderContext.setOrder(item);
        });
        orderContext.setOpenEdit(true);
    };
    let myFactors=orderContext.factors;
    const statusColors = {
        1: 'pending',
        2: 'returned',
        4: 'cleared',
        6: 'delivered-to-host',
        8: 'delivered-to-iran',
        10: 'waiting-to-buy',
        12: 'buy-completed',
        14: 'sending-to-iran',
        16: 'canceled',
        17: 'not-available',
    };

    const handleStatusChange = (orderId, statusId) => {
        const formData = new FormData();
        formData.append('order_id', orderId);
        formData.append('status_id', statusId);
        updateStatus(formData)
            .then(() => {
                orderContext.fetchData();
            })
    };

    const handleStatusFactorChange = (orderId, factorId) => {
        if(factorId != 0 ){
            const formData = new FormData();
            formData.append('order_id', orderId);
            formData.append('factor_id', factorId);
            updateFactor(formData)
                .then(() => {
                    orderContext.fetchData();
                })
        }
    };

    // Table columns
    const columns = [
        {
            dataField: "priority",
            text: "شماره",
            style: {minWidth: '5em', textAlign: 'center'},
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: 'x',
            text: 'تصویر',
            style: {minWidth: '10em', textAlign: 'center'},
            formatter: (cellContent, row,) => {
                const imageObj = row.product.images[0];
                return (
                    <Image thumbnail src={imageObj && domain + imageObj.url}
                           style={{height: '150px', width: 'auto'}} key={imageObj.id}/>)

            },
        },
        {
            dataField: "id",
            text: "شناسه سفارش",
            style: {minWidth: '5em', textAlign: 'center'},
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "product_id",
            text: "شناسه محصول",
            style: {minWidth: '5em', textAlign: 'center'},
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "user_id",
            text: "شناسه کاربر",
            style: {minWidth: '5em', textAlign: 'center'},
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "price",
            text: "قیمت",
            style: {minWidth: '7em', textAlign: 'center'},
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "quantity",
            text: "تعداد",
            style: {minWidth: '5em', textAlign: 'center'},
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "z",
            text: "وضعیت",
            style: {minWidth: '9em', textAlign: 'center'},
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: (cellContent, row) => {
                return (
                    <>
                        <div className={`status ${statusColors[row.status_id]} mb-5`}>
                            <span>{row.status.name}</span>
                        </div>
                        <div>
                            <select onChange={e => handleStatusChange(row.id, e.target.value)}
                                    defaultValue={row.status_id}>
                                {orderContext.statuses.map((item, key) =>
                                    <option key={key} defaultChecked={row.status_id === item.id ? true : false}
                                            value={item.id}>{item.name}</option>
                                )}
                            </select>
                        </div>
                    </>
                )
            }
        },
        {
            dataField: "ff",
            text: "فاکتور",
            style: {minWidth: '9em', textAlign: 'center'},
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: (cellContent, row) => {
                return (
                    <>
                        <span>{row.factor_id === 0 ? <button className="btn btn-warning">بدون فاکتور</button> :  <button className="btn btn-success">فاکتور شماره{row.factor_id} </button>}</span>
                        <div>
                            {row.factor_id === 0 ?
                                <select onChange={e => handleStatusFactorChange(row.id, e.target.value)}
                                        defaultValue={row.factor_id}>
                                    <option value='0'>انتخاب کنید</option>
                                    {orderContext.factors.map((item, key) =>
                                        <option key={key} defaultChecked={row.factor_id === item.id ? true : false}
                                                value={item.id}>{item.id}
                                        </option>
                                    )}
                                </select>
                                :
                                <></>

                            }

                        </div>
                    </>
                )
            }
        },
        {
            dataField: "created_at",
            text: "تاریخ ایجاد",
            style: {minWidth: '7em', textAlign: 'center'},
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: (date) => {
                if (date) {
                    const createdDate = moment(date, 'YYYY-M-D HH:mm:ss').format('jYYYY/jMM/jDD HH:mm:ss');
                    return <>{createdDate}</>;
                }
            },
        },
        {
            dataField: "xx",
            text: "سایر",
            style: {minWidth: '12em', textAlign: 'right'},
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: (cellContent, row) => {
                return (
                    <ul className="pl-2 nested-table-list">
                        <li><span>برند : <strong>{row.product.brandName}</strong></span></li>
                        <li>
                            <span> سایز : <strong>{row && `${row.variant?.attributeName} - ${row.variant?.attributeType} - ${row.variant?.attributeValue}`}</strong></span>
                        </li>
                        <li><span> قیمت لیر : <strong>{row.parameters && `${row.parameters?.lir_price}`}</strong></span>
                        </li>
                        <li><span> شناسه آیتم : <strong>{row.parameters && `${row.parameters?.order_item_id}`}</strong></span>
                        </li>
                        <li>
                            <span> شناسه سفارش : <strong>{row.parameters && `${row.parameters?.order_id}`}</strong></span>
                        </li>
                        <li>
                            <span> لیر روز : <strong>{row.parameters && `${row.parameters?.sold_lire_price}`} TL</strong></span>
                        </li>

                    </ul>
                )
            },
        },
        {
            dataField: "action",
            text: "عملیات",
            formatter: columnFormatters.ActionsColumnFormatter,
            formatExtraData: {
                openEditPage: handleEdit,
            },
            classes: "text-right pr-0",
            headerClasses: "text-right pr-3",
            style: {
                minWidth: "9em",
            },
        },
    ];

    return (
        <>
            {!!data.data &&
            <TableLayout activePage={activePage} columns={columns} data={data}/>
            }

        </>
    )
}